import { Observable } from 'ub_wrapped/rx';

import planFeatures from 'ub/plan-features.js';

import endpoints from 'ub/config/endpoints';

import svgUploadHelper from 'ub/ui/svg/svg-upload';
import ajaxAsObservable from 'ub/control/ajax-as-observable';

const ALLOWED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  ...(planFeatures.isFeatureEnabled('svgUpload') ? ['image/svg+xml'] : []),
];

function parseAssetUploadResponse(payload) {
  // this is a hack to work around the lack of a json response from lp-webapp.
  // The response is HTML with a script tag that calls a callback.
  const prefix = 'assetUploaded(';
  const badjson = payload.substring(
    payload.indexOf(prefix) + prefix.length,
    payload.indexOf('});') + 1
  );
  const goodjson = badjson.replace(/\s*([a-z_]+):/g, '"$1":').replace(/'/g, '"');
  const parsed = JSON.parse(goodjson);
  return { ...parsed, id: parseInt(parsed.id, 10) };
}

export function isValidImageType(mimeType) {
  return ALLOWED_IMAGE_MIME_TYPES.includes(mimeType);
}

const CONCURRENT_UPLOADS = 1;

export function uploadFiles$(files, authToken, onlyImages) {
  return Observable.fromPromise(svgUploadHelper.addColorClassesToSvgs(files))
    .flatMap(files => Observable.fromArray(files))
    .flatMapWithMaxConcurrent(CONCURRENT_UPLOADS, (file, index) => {
      if (onlyImages && !isValidImageType(file.type)) {
        return Observable.of({
          error: new Error('Invalid file type'),
          file,
        });
      }

      var data = new FormData();
      data.append('authenticity_token', authToken);
      data.append('only_images', onlyImages);

      // For multiple image upload batches, we tell the webapp to hold off updating
      // memcache until the final image.
      data.append('update_cache', index === files.length - 1);
      data.append('asset[content]', file);

      return ajaxAsObservable({
        type: 'POST',
        url: endpoints.assetsByCompanyId(window.editor.currentCompanyId),
        contentType: false,
        processData: false,
        data: data,
      })
        .retry(3)
        .map(response => {
          const errorMessageMatch = response.data.match(/assetUploadFailed\((.+)\)/);

          if (errorMessageMatch) {
            return {
              error: new Error(JSON.parse(errorMessageMatch[1]).join(', ')),
              file,
            };
          } else {
            return {
              asset: parseAssetUploadResponse(response.data),
              error: null,
            };
          }
        })
        .catch(() =>
          Observable.of({
            error: new Error('Upload failed'),
            file,
          })
        );
    });
}



// WEBPACK FOOTER //
// ./src/control/asset-upload.js